import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'disruption_compensation_hub';
export const route = 'disruption_compensation_hub/[bookingId]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/DisruptionCompensationPage').then(({
  DisruptionCompensationPageHub
}) => ({
  default: DisruptionCompensationPageHub
}))));